import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';

import { map, catchError } from 'rxjs/operators';

import {
  RoutingActionTypes,
  FetchRecentRoutesSuccess,
  FetchRecentRoutesFailure,
  UpdateRecentRoutesSuccess,
  UpdateRecentRoutesFailure,
} from '../actions/routing.actions';
import { RecentRoute } from '../../models/RecentRoutes';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class RoutingEffects {
  @Effect()
  fetchRecentRoutes = this.actions$.pipe(
    ofType(RoutingActionTypes.FetchRecentRoutes),
    map(() => {
      const routes =
        JSON.parse(localStorage.getItem('recent_routes')) ||
        ([] as RecentRoute[]);
      return new FetchRecentRoutesSuccess(routes);
    }),
    catchError((e) => {
      this.toastr.error('Could not load recent routes');
      console.error(e);
      return [new FetchRecentRoutesFailure()];
    }),
  );

  @Effect()
  updateRecentRoutes = this.actions$.pipe(
    ofType(RoutingActionTypes.UpdateRecentRoutes),
    map(({ payload }) => {
      const routes: RecentRoute[] =
        JSON.parse(localStorage.getItem('recent_routes')) ||
        ([] as RecentRoute[]);
      routes.forEach((r) => {
        return { ...r, id: r.id++ };
      });
      routes.unshift(payload);
      const newUniqueRecents = Array.from(
        new Set(routes.map((r) => r.url)),
      ).map((url) => {
        return routes.find((r) => r.url === url);
      });
      localStorage.setItem('recent_routes', JSON.stringify(newUniqueRecents));
      return new UpdateRecentRoutesSuccess(newUniqueRecents);
    }),
    catchError((e) => {
      this.toastr.error('Could not load recent routes');
      console.error(e);
      return [new UpdateRecentRoutesFailure()];
    }),
  );
  constructor(private actions$: Actions, private toastr: ToastrService) {}
}
